import { phasesTypes } from "../constantes/actionTypes"

const initialState = []

export const phases = (state = initialState, action) => {
    switch (action.type) {
        case phasesTypes.GET_ALL_PHASES_SUCCESS:
            return action.payload
        case phasesTypes.GET_ALL__PHASES_FAILURE:
            return initialState
        default:
            return state
    }
}